import React, { useRef } from 'react'
import { Animated, Pressable, PressableProps, ViewStyle } from 'react-native'

interface Props extends PressableProps {
  children?: React.ReactNode
}

const AnimatedPressable = Animated.createAnimatedComponent(Pressable)

export function PressableOpacity({ children, ...props }: Props) {
  const animated = useRef(new Animated.Value(1)).current
  const styles = props.style
  const fadeIn = () => {
    Animated.timing(animated, {
      toValue: 0.4,
      duration: 100,
      useNativeDriver: true,
    }).start()
  }
  const fadeOut = () => {
    Animated.timing(animated, {
      toValue: 1,
      duration: 100,
      useNativeDriver: true,
    }).start()
  }

  return (
    <AnimatedPressable
      onPressIn={fadeIn}
      onPressOut={fadeOut}
      {...props}
      style={[styles as ViewStyle, { opacity: animated }]}
    >
      {children}
    </AnimatedPressable>
  )
}
